module.exports = __webpack_public_path__ + "img/globalmedic-fb-share.d89490fd.jpg";